import { Loading } from "components/ui/Loading/Loading";
import { AuthContext } from "hooks/authProvider/authProvider";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Cognito OAuth コールバック受け皿。
 * トークン交換とユーザー取得が終わるまで /redirect に留まり、完了後に / へ遷移する。
 * （完了前に / へ抜けると外側ルート切替で OAuth 処理が中断され得る）
 * @return {JSX.Element} ローディング表示
 */
const RedirectPage = () => {
  const navigate = useNavigate();
  const { currentUser, isLoadingUser } = useContext(AuthContext);

  useEffect(() => {
    if (isLoadingUser) return;

    if (currentUser) {
      navigate("/", { replace: true });
      return;
    }

    navigate("/login", { replace: true });
  }, [isLoadingUser, currentUser, navigate]);

  return (
    <div className="flex justify-center mt-52">
      <Loading size="md" />
    </div>
  );
};

export default RedirectPage;
